import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { shortDate } from "LIB/formatters/date";
import {
  DataTable,
  Icon,
  PartNumber,
  SearchPropTypes
} from "MODULES/shared/components";
import { Link } from "react-router-dom";
import { dollars } from "LIB/formatters/currency";

const getClass = cancelled =>
  classNames({
    "danger-table-cap": cancelled
  });

function RmaStatusCell({ cancelled, children }) {
  return <td className={getClass(cancelled)}>{children}</td>;
}

RmaStatusCell.propTypes = {
  cancelled: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};

function renderRow(r, pushHistory) {
  const rowClasses = classNames("clickable", { "text-muted": r.cancelled });
  const handleMailto = e => {
    e.stopPropagation();
  };

  const lineItem = r.sales_item;

  return (
    <tr
      key={r.id}
      className={rowClasses}
      onClick={() => pushHistory(`/rmas/${r.uuid}`)}
    >
      <td>{r.code}</td>
      <td>{r.reference_record_code}</td>
      <td>{shortDate(r.created_at)}</td>
      <td>{shortDate(r.date_in)}</td>
      <td className="text-center">{shortDate(r.closed_date)}</td>
      <td>{r.company_name}</td>
      <td>{r.contact_name}</td>
      <td>{r.company_phone}</td>
      <td>
        <a href={`mailto:${r.contact_email}`} onClick={handleMailto}>
          {r.contact_email}
        </a>
      </td>
      <td>
        <PartNumber part={r.part} />
      </td>
      <td>
        <Link
          onClick={e => e.stopPropagation()}
          to={`/inventories/${r.inventory.uuid}`}
        >
          {r.sales_item && r.sales_item.serial_number}
        </Link>
      </td>
      <td className="text-right">
        {(lineItem.exchange_sale && dollars(lineItem.exchange_fee)) ||
          dollars(lineItem.price_per_unit)}
      </td>
      <td className="text-right">
        {lineItem.exchange_sale && dollars(lineItem.outright_value)}
      </td>
      <td className="text-center">
        {r.warranty_consideration && <Icon name="check text-success" />}
      </td>
      <td className="text-center">
        {r.credit_requested && <Icon name="check text-success" />}
      </td>
    </tr>
  );
}

export function Table({ isLoading, pageActions, results, pushHistory }) {
  return (
    <DataTable loading={isLoading} refresh={pageActions.expire}>
      <DataTable.Head>
        <th>RMA #</th>
        <th>Ref #</th>
        <th>Date Created</th>
        <th>Date Received</th>
        <th className="text-center">Date Closed</th>
        <th>Customer</th>
        <th>Contact</th>
        <th>Phone</th>
        <th>Email</th>
        <th>Part #</th>
        <th>Serial #</th>
        <th className="text-right">Exch Fee/Sales EA</th>
        <th className="text-right">Outright Value</th>
        <th className="text-center">Warr Rqstd</th>
        <th className="text-center">Credit Rqstd</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(r => renderRow(r, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/CustomerRmas/components/Table.jsx